import Breadcrumb from "../../components/Breadcrumb/Breadcrumb.js";
import TournamentPayoutTable from "../../components/PayoutTable/TournamentPayoutTable.js";
import TournamentSubpageHead from "../../components/SEO/TournamentSubpageHead";

import { useTournamentId, useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";

export default function PayoutTablePage() {
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Tournaments", path: "/tournaments" },
    { label: "Tournament", path: tournamentPath(tournamentSlug) },
    { label: "Payouts" },
  ];

  return (
    <>
      <TournamentSubpageHead page="payout" />
      <div className="flex justify-center mb-3 sm:mb-4 px-4 sm:px-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>
      <div className="card-board overflow-hidden mb-6">
        <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
          <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
            Payouts
          </h1>
          <p className="text-sm text-brand-mist mt-1">
            Payout table for this tournament.
          </p>
        </div>
      </div>
      <TournamentPayoutTable tournamentId={tournamentId} embedded />
    </>
  );
}
